import React, { Fragment, useState, useEffect } from 'react'
import { Form, Input, Button, Select, Layout, Row, Col, Card, Breadcrumb, Typography, Upload, List, message } from 'antd';
import { Link, Redirect } from 'react-router-dom';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import Axios from 'axios';
import { url } from '../../config/global';
import moment from 'moment';

const { Title } = Typography
const { Option } = Select;
const { Content } = Layout
const { TextArea } = Input

const layout = {
    labelCol: {
        lg: 8,
        md: 10
    },
    wrapperCol: {
        lg: 8,
        md: 14
    },
}
const tailLayout = {
    wrapperCol: {
        offset: 8,
        span: 16,
    },
}

function EditMeetingRoom(props) {

    const [data, setData] = useState({
        name: '',
        description: '',
        photo: ''
    })

    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getUser()
    }, [])

    const getUser = () => {
        Axios.get(`${url}/room/${props.match.params.id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            setData({
                ...data,
                name: res.data.data.name,
                ext: res.data.data.ext,
                description: res.data.data.description,
                photo: res.data.data.photo,
            })
        }).catch(err => {
            if (err.response) {
                message.error(err.response.data.message)
                if (err.response.status == 401) {
                    localStorage.removeItem('token')
                }
            }
        })
    }

    const handleRemove = () => {
        setData({
            ...data,
            photo: null
        })
    }

    const handleBeforeUpload = (files) => {

        setData({
            ...data,
            photo: files
        })

        return false
    }

    const handleChange = (name, value) => {
        setError(null)
        setData({
            ...data,
            [name]: value
        })
    }

    const onSaveData = () => {

        setLoading(true)

        let fd = new FormData()

        fd.set('name', data.name)
        fd.set('description', data.description)
        fd.set('ext', data.ext)
        if (data.photo) {
            fd.append('image_file', data.photo)
        }

        Axios.post(`${url}/room/${props.match.params.id}`, fd, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `Bearer ${localStorage.getItem('token')}`
            }
        }).then(res => {
            message.success(res.data.message)
            props.history.push('/meeting-room')
        }).catch(err => {
            if (err.response) {
                message.error(err.response.data.message)
                if (err.response.status === 422) {
                    setError(err.response.data.errors)
                }
                if (err.response.status == 401) {
                    localStorage.removeItem('token')
                }
            }
            setLoading(false)
        })
    }

    const handleReset = () => {
        setData({
            name: '',
            description: '',
            photo: null,
        })
    }

    if (!localStorage.getItem('token')) {
        return <Redirect to="/login" />
    }

    return (
        <Fragment>
            <Row>
                <Col xs={24}>
                    <Card type="inner" title="Meeting Room" extra={moment(new Date()).format('DD MMMM YYYY')}>
                        <Row type="flex" justify="left">
                            <Breadcrumb>
                                <Breadcrumb.Item>
                                    <Link to="/meeting-room">Back</Link>
                                </Breadcrumb.Item>
                                <Breadcrumb.Item>Edit Meeting Room</Breadcrumb.Item>
                            </Breadcrumb>
                        </Row>
                    </Card>
                </Col>
            </Row>
            <Content className="content">
                <Row>
                    <Col xs={24}>
                        <Card className="body-data">
                            <Form
                                {...layout}
                                name="control-hooks"
                                onFinish={onSaveData}
                            >
                                <Form.Item
                                    required
                                    label="Name"
                                    validateStatus={error && error.name ? 'error' : false}
                                    help={error && error.name ? error.name[0] : false}
                                >
                                    <Input value={data.name} onChange={(e) => handleChange('name', e.target.value)} />
                                </Form.Item>
                                <Form.Item
                                    required
                                    label="Description"
                                    validateStatus={error && error.description ? 'error' : false}
                                    help={error && error.description ? error.description[0] : false}
                                >
                                    <TextArea value={data.description} onChange={(e) => handleChange('description', e.target.value)} rows={4} />
                                </Form.Item>
                                <Form.Item
                                    label="Ext"
                                    validateStatus={error && error.ext ? 'error' : false}
                                    help={error && error.ext ? error.ext[0] : false}
                                >
                                    <Input value={data.ext} onChange={(e) => handleChange('ext', e.target.value)} />
                                </Form.Item>
                                <Form.Item
                                    name="photo"
                                    label="Photo"
                                    extra="Besaran file maksimal 2MB"
                                >
                                    <Fragment>
                                        <Upload onRemove={handleRemove} beforeUpload={handleBeforeUpload} fileList={[]}>
                                            <Button>
                                                Upload <UploadOutlined />
                                            </Button>
                                        </Upload>
                                        {
                                            data.photo && <List>
                                                <List.Item actions={[<Button onClick={handleRemove} type="danger" ghost><DeleteOutlined /></Button>]}>
                                                    <List.Item.Meta description={data.photo.name} />
                                                </List.Item>
                                            </List>
                                        }
                                    </Fragment>
                                </Form.Item>
                                <Form.Item {...tailLayout}>
                                    <Button loading={loading} type="primary" htmlType="submit" className="mr-button">
                                        Submit
                                    </Button>
                                    <Button htmlType="reset" onClick={handleReset}>
                                        Reset
                                    </Button>
                                </Form.Item>

                            </Form>
                        </Card>
                    </Col>
                </Row>

            </Content>
        </Fragment>
    )
}

export default EditMeetingRoom